export default __webpack_public_path__ + "static/media/Mikasa.c9322194.jpg";